<template>
	<v-container fluid class="mx-5 mt-5 project-container">
		<v-layout style="width:98%">
			<v-row>
				<v-col sm="6" lg="6">
					<v-breadcrumbs :items="itemsBreadcrumb" class="breadcrumb">
						<template v-slot:divider>
							<v-icon>mdi-chevron-right</v-icon>
						</template>
						<template v-slot:item="{ item }">
							<v-breadcrumbs-item :href="item.href">
								{{ item.text }}
							</v-breadcrumbs-item>
						</template>
					</v-breadcrumbs>
				</v-col>
				<v-col sm="6" lg="6" class="text-right pr-10">
					<div style="display:inline-block" class="pr-4">
						<div v-if="canAudit()">
							<icon
								:name="$t('audit.preApprove')"
								@clicked="auditResult(true)"
								style="background-color:red"
								:disableIcon="
									project.status === 'Approved' ||
										project.status === 'PreApproved'
								"
								icon="mdi-check-circle-outline"
							></icon>
							<icon
								:name="$t('audit.deny')"
								@clicked="auditResult(false)"
								:disableIcon="project.status === 'Denied'"
								icon="mdi-close-circle-outline"
							></icon>
						</div>
						<div v-if="canLegalAudit()">
							<icon
								:name="$t('audit.approve')"
								@clicked="legalAuditResult(true)"
								style="background-color:red"
								:disableIcon="
									project.status === 'Approved' || project.status === 'Denied'
								"
								icon="mdi-check-circle-outline"
							></icon>
							<icon
								:name="$t('audit.deny')"
								@clicked="legalAuditResult(false)"
								:disableIcon="project.status === 'Denied'"
								icon="mdi-close-circle-outline"
							></icon>
						</div>
					</div>
					<v-btn
						outlined
						rounded
						small
						:disabled="downloadInProgress || downloadNotAllowed"
						@click.native="downloadSummary()"
						class="download px-2 pt-4 pb-4 py-2"
					>
						<v-icon>mdi-file-pdf-outline</v-icon>
						{{ $t("downloadSummary") }}
					</v-btn>
					<v-tooltip bottom :disabled="!disableOrganismButton">
						<template v-slot:activator="{ on }">
							<div v-on="on" class="d-inline-block">
								<v-btn
									v-if="isDownloader"
									outlined
									rounded
									small
									:disabled="disableOrganismButton"
									@click.native="shareProject()"
									class="download px-2 pt-4 pb-4 py-2 share-button"
								>
									<v-icon>mdi-file-pdf-outline</v-icon>
									{{ $t("manageSecondaryOrganisms") }}
								</v-btn>
							</div>
						</template>
						<span>{{ $t(getDisableText) }}</span>
					</v-tooltip>
				</v-col>
			</v-row>
		</v-layout>

		<table-project-details :project="project" />
		<audit-dialog v-if="dialog" v-on:refreshData="getData()" />
		<file-details-drawer
			v-if="showDrawer"
			:projectName="projectName"
			:drawerProp="showDrawer"
			:extraction="extractionForDrawer"
			:key="drawerKey"
			class="px-2 text-capitalize"
		/>
		<v-data-table
			v-model="selected"
			:headers="headers"
			:items="extractions"
			item-key="cameraName"
			show-expand
			class="elevation-0 mt-6 cameras-table ml-5 blanco"
			hide-default-footer
			disable-pagination
			:mobile-breakpoint="685"
		>
			<template #item.cameraName="{item}">
				<v-col class="camera-name">
					{{ item.cameraName }}
				</v-col>
			</template>
			<template #item.status="{item}" v-on:click="onClick()">
				<status-box :status="item.status" class="status" />
			</template>
			<template #item.warning="{item}">
				<v-row justify="start" v-for="warning in item.warning" :key="warning">
					<span id="warning">{{ warning }}</span>
				</v-row>
			</template>
			<template #item.actions="{}">
				<icon
					:name="$t('audit.preApprove')"
					v-if="canAudit()"
					@clicked="auditResult(true)"
					:disableIcon="project.status === 'Approved'"
					icon="mdi-check-circle-outline"
				></icon>
				<icon
					:name="$t('audit.deny')"
					v-if="canAudit()"
					@clicked="auditResult(false)"
					:disableIcon="project.status === 'Denied'"
					icon="mdi-close-circle-outline"
				></icon>
			</template>
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length" class="pl-0 pr-0 table-td">
					<!--extractions without warnings-->
					<v-row
						style="justify-content: start!important"
						class="ml-4 table-no-part"
						v-if="!checkWarnings"
					>
						<v-col
							cols="4"
							sm="4"
							md="3"
							lg="3"
							class="py-2 pt-2 my-0 title-expansion"
						>
							<p class="pa-0 ma-0">{{ $t("timeRange") }}</p>
						</v-col>
						<v-col
							cols="3"
							sm="4"
							md="2"
							lg="2"
							class="py-2 pt-2 my-0 title-expansion"
						>
							<p class="pa-0 ma-0">{{ $t("size") }}</p>
						</v-col>
						<v-col
							cols="4"
							sm="4"
							md="2"
							lg="2"
							class="py-2 pt-2 my-0 title-expansion"
						>
							<p class="pa-0 ma-0">{{ $t("status") }}</p>
						</v-col>
						<v-col
							cols="4"
							sm="4"
							md="3"
							lg="3"
							class="py-2 pt-2 my-0 title-expansion"
						>
							<p class="pa-0 ma-0"></p>
						</v-col>
					</v-row>
					<v-row
						v-for="extraction in extractionsGrouped(item.cameraName)"
						:key="extraction.key"
						@click="onClick(extraction)"
						class="ml-4 row-divider table-no-part"
						style="justify-content:flex-start!important"
					>
						<v-col cols="4" sm="4" md="3" lg="3" v-if="!checkWarnings">
							<span class="grey--text content">{{ $t("from") }}</span>
							<span
								class="content"
								v-if="
									extraction.timeRange.split(' - ')[0] !== '0001-01-01T00:00:00'
								"
								>{{
									parseTimePeriod(extraction.timeRange.split(" - ")[0])
								}}</span
							>
							<span class="content" v-else>{{
								parseTimePeriod(extraction.timeRangeName.split(" - ")[0])
							}}</span>
							<br />
							<span class="grey--text content"> {{ $t("to") }} </span>
							<span
								class="content"
								v-if="
									extraction.timeRange.split(' - ')[1] !== '0001-01-01T00:00:00'
								"
								>{{
									parseTimePeriod(extraction.timeRange.split(" - ")[1])
								}}</span
							>
							<span class="content" v-else>{{
								parseTimePeriod(extraction.timeRangeName.split(" - ")[1])
							}}</span>
						</v-col>
						<v-col
							cols="3"
							sm="4"
							md="2"
							lg="2"
							v-if="!checkWarnings"
							class="content"
						>
							{{ extraction.size }}
						</v-col>
						<v-col cols="4" sm="4" md="2" lg="2" v-if="!checkWarnings">
							<status-box :status="extraction.status" class="content" />
						</v-col>
						<v-col cols="4" sm="4" md="3" lg="2" v-if="!checkWarnings">
							{{ extraction.warning }}
						</v-col>
						<v-col cols="12" md="2" sm="6" lg="3" v-if="!checkWarnings">
							<v-btn
								small
								rounded
								class="white--text mr-2 pa-4 download-cam"
								color="#5f98ed"
								:disabled="singleDownloadNotAllowed(extraction)"
								v-on:click.stop="download(extraction)"
							>
								{{ $t("download") }}
							</v-btn>
							<v-btn text class="show-details pl-2">Ver Detalles</v-btn>
						</v-col>
					</v-row>
					<!--extractions without warnings responsive-->
					<v-layout
						v-for="(extraction, index) in extractionsGrouped(item.cameraName)"
						:key="index"
						@click="onClick(extraction)"
						class="row-divider table-no-part-resp"
						style="justify-content:flex-start!important"
					>
						<v-row class="ml-3" v-if="!checkWarnings">
							<v-col cols="5" sm="4" class="py-2 pt-2 my-0 title-expansion">
								<p class="pa-0 ma-0">{{ $t("timeRange") }}</p>
							</v-col>
							<v-col
								cols="7"
								sm="4"
								v-if="!checkWarnings"
								class="title-expansion"
							>
								<span class="grey--text content">{{ $t("from") }}</span>
								<span
									class="content"
									v-if="
										extraction.timeRange.split(' - ')[0] !==
											'0001-01-01T00:00:00'
									"
									>{{
										parseTimePeriod(extraction.timeRange.split(" - ")[0])
									}}</span
								>
								<span class="content" v-else>{{
									parseTimePeriod(extraction.timeRangeName.split(" - ")[0])
								}}</span>
								<br />
								<span class="grey--text content"> {{ $t("to") }} </span>
								<span
									class="content"
									v-if="
										extraction.timeRange.split(' - ')[1] !==
											'0001-01-01T00:00:00'
									"
									>{{
										parseTimePeriod(extraction.timeRange.split(" - ")[1])
									}}</span
								>
								<span class="content" v-else>{{
									parseTimePeriod(extraction.timeRangeName.split(" - ")[1])
								}}</span>
							</v-col>
						</v-row>
						<v-row class="ml-3" v-if="!checkWarnings">
							<v-col
								cols="5"
								sm="4"
								md="2"
								lg="2"
								class="py-2 pt-2 my-0 title-expansion"
							>
								<p class="pa-0 ma-0">{{ $t("size") }}</p>
							</v-col>
							<v-col
								cols="7"
								sm="4"
								md="2"
								lg="2"
								v-if="!checkWarnings"
								class="content"
							>
								{{ extraction.size }}
							</v-col>
						</v-row>
						<v-row class="ml-3" v-if="!checkWarnings">
							<v-col
								cols="5"
								sm="4"
								md="2"
								lg="2"
								class="py-2 pt-5 my-0 title-expansion"
							>
								<p class="pa-0 ma-0">{{ $t("status") }}</p>
							</v-col>
							<v-col
								cols="7"
								sm="4"
								md="2"
								lg="2"
								v-if="!checkWarnings"
								class="content"
							>
								<status-box :status="extraction.status" class="content" />
							</v-col>
						</v-row>
						<v-row class="ml-3" v-if="!checkWarnings">
							<v-col cols="10" sm="4" md="3" lg="2" v-if="!checkWarnings">
								{{ extraction.warning }}
							</v-col>
						</v-row>
						<v-row class="ml-3" v-if="!checkWarnings">
							<v-col cols="12" md="2" sm="6" lg="3" v-if="!checkWarnings">
								<v-btn
									small
									rounded
									class="white--text mr-2 pa-4 download-cam"
									color="#5f98ed"
									:disabled="singleDownloadNotAllowed(extraction)"
									v-on:click.stop="download(extraction)"
								>
									{{ $t("download") }}
								</v-btn>
								<v-btn text class="show-details pl-2">Ver Detalles</v-btn>
							</v-col>
						</v-row>
					</v-layout>
					<!--Partitioned extractions-->
					<div v-if="checkWarnings">
						<v-expansion-panels
							v-for="(panelExt, index) in getExtractions(
								extractionsGrouped(item.cameraName)
							)"
							:key="index"
							class="elevation-0 pt-6 panel expansion-panel-head"
						>
							<v-expansion-panel class="elevation-0 expansion-panel ">
								<v-expansion-panel-header
									class="py-0 elevation-0 expansion-header expansion-align"
								>
									<v-row class="expansion-row" @click="isDown = !isDown">
										<v-col
											class="py-2 pt-2 my-0 title-expansion time-col-width "
										>
											<p class="pa-0 ma-0">{{ $t("timeRange") }}</p>
										</v-col>
										<v-col
											class="py-2 pt-2 my-0 title-expansion ml-4 size-col-width"
										>
											<p class="pa-0 ma-0">{{ $t("totalSize") }}</p>
										</v-col>
										<v-col
											cols="4"
											md="3"
											lg="2"
											class="py-2 pt-2 my-0 title-expansion status-col-width"
										>
											<p class="pa-0 ma-0">{{ $t("status") }}</p>
										</v-col>
										<v-col
											class="py-2 pt-2 my-0 title-expansion part-col-width"
										>
											<p class="pa-0 ma-0">{{ $t("partitions") }}</p>
										</v-col>
										<v-col
											cols="4"
											md="3"
											lg="3"
											class="py-2 pt-2 my-0 title-expansion"
										>
											<p class="pa-0 ma-0"></p>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-header
									class="py-0 elevation-0 expansion-header"
								>
									<v-row class="expansion-row" @click="isDown = !isDown">
										<v-col class="py-2 pt-2 my-0 pl-0 pr-0 icon-down-up">
											<v-icon v-if="!isDown" @click="isDown = false"
												>mdi-chevron-down</v-icon
											>
											<v-icon v-if="isDown" @click="isDown = true"
												>mdi-chevron-up</v-icon
											>
										</v-col>
										<v-col
											class="py-2 pt-2 my-0 time-col-width timerange-col-width"
										>
											<span class="grey--text title-expansion content">{{
												$t("from")
											}}</span>
											<span class="title-expansion content"
												>{{
													parseTimePeriod(
														panelExt.timeRangeName.split(" - ")[0]
													)
												}}
											</span>
											<br />
											<span class="grey--text title-expansion content">
												{{ $t("to") }}
											</span>
											<span class="title-expansion content">{{
												parseTimePeriod(panelExt.timeRangeName.split(" - ")[1])
											}}</span>
											<br />
											<span v-if="noDate" class="title-not-possible">{{
												$t("itsNotPossible")
											}}</span>
										</v-col>
										<v-col
											class="py-2 pt-2 my-0 size-col-width totalsize-col-width"
										>
											<p class="mt-2 title-expansion content-expansion content">
												{{
													getTotalSizeWarning(
														extractionsGrouped(item.cameraName),
														panelExt.id
													)
												}}
											</p>
										</v-col>
										<v-col
											class="py-2 pt-2 my-0 status-col-width totalstatus-col-width"
										>
											<status-box :status="item.status" class="content" />
										</v-col>
										<v-col class="py-2 pt-2 my-0 part-col-width">
											<p class="mt-2 title-expansion content">
												{{ $t("partitionedFileMsg") }}
											</p>
										</v-col>
										<v-col
											cols="4"
											md="3"
											lg="4"
											class="py-2 pt-2 my-0 download-col-width"
										>
											<p
												v-if="extractionProblems(item)"
												class="title-expansion"
											>
												{{ $t("haveProblems") }}
											</p>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content
									class="expansion-panel-content panel-content-part"
								>
									<v-row
										v-for="(ext, index) in getExtractionsGrouped(
											extractionsGrouped(item.cameraName),
											panelExt.id
										)"
										:key="index"
										@click="onClick(ext)"
										class="row-align"
										style="justify-content:flex-start!important"
									>
										<v-col
											v-if="checkWarnings"
											class="time-col-width time-col-align"
										>
											<span class="grey--text content">{{ $t("from") }}</span>
											<span class="content"
												>{{ parseTimePeriod(ext.timeRange.split(" - ")[0]) }}
											</span>
											<br />
											<span class="grey--text content"> {{ $t("to") }} </span>
											<span class="content">{{
												parseTimePeriod(ext.timeRange.split(" - ")[1])
											}}</span>
										</v-col>
										<v-col
											v-if="checkWarnings"
											class="size-col-width size-col-align"
										>
											<span class="content">{{ ext.size }}</span>
										</v-col>
										<v-col
											v-if="checkWarnings"
											class="status-col-width status-col-align"
										>
											<status-box :status="ext.status" class="content" />
										</v-col>
										<v-col
											v-if="checkWarnings"
											class="part-col-width part-col-align"
										>
											<span
												class="content"
												v-for="msg in getWarningsMsg(ext.warning)"
												:key="msg"
											>
												{{ msg }} <br />
											</span>
										</v-col>
										<v-col v-if="checkWarnings" class="pa-0 download-col-width">
											<v-btn
												small
												rounded
												class="white--text mr-2 pa-3 download-cam"
												color="#5f98ed"
												:disabled="singleDownloadNotAllowed(ext)"
												v-on:click.stop="download(ext)"
											>
												{{ $t("download") }}
											</v-btn>
											<v-btn text class="show-details pl-2" @click="onClick">{{
												$t("showDetails")
											}}</v-btn>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</div>

					<!--expansion to responsive-->
					<div v-if="checkWarnings">
						<v-expansion-panels
							class="elevation-0 pt-6 hidden-md-and-up"
							v-for="(panelExt, index) in getExtractions(
								extractionsGrouped(item.cameraName)
							)"
							:key="index"
						>
							<v-expansion-panel class="elevation-0 expansion-panel">
								<v-expansion-panel-header
									class="py-0 elevation-0 expansion-header"
								>
									<v-row class="expansion-row mb-6" @click="isDown = !isDown">
										<v-col cols="1" sm="12" class="py-2 pt-0 my-0 pl-2 pr-0">
											<v-icon v-if="!isDown" @click="isDown = false"
												>mdi-chevron-down</v-icon
											>
											<v-icon v-if="isDown" @click="isDown = true"
												>mdi-chevron-up</v-icon
											>
										</v-col>
									</v-row>
									<v-row class="expansion-row" @click="isDown = !isDown">
										<v-col
											cols="5"
											sm="5"
											class="py-2 pt-2 my-0 title-expansion"
										>
											<p class="pa-0 ma-0">{{ $t("timeRange") }}</p>
										</v-col>
										<v-col
											cols="6"
											sm="7"
											class="py-2 pt-2 my-0 pr-0 pl-2 title-expansion-cont from-to"
										>
											<span class="grey--text title-expansion content">{{
												$t("from")
											}}</span>
											<span class="title-expansion content"
												>{{
													getMinTime(
														getExtractionsGrouped(
															extractionsGrouped(item.cameraName),
															panelExt.id
														)
													)
												}}
											</span>
											<span class="grey--text title-expansion content">
												{{ $t("to") }}
											</span>
											<span class="title-expansion content">{{
												getMaxTime(
													getExtractionsGrouped(
														extractionsGrouped(item.cameraName),
														panelExt.id
													)
												)
											}}</span>
										</v-col>
										<v-col
											cols="5"
											sm="5"
											class="py-2 mt-0 my-0 title-expansion responsive-title"
										>
											<p class="pa-0 ma-0">{{ $t("totalSize") }}</p>
										</v-col>
										<v-col
											cols="7"
											sm="7"
											class="py-2 mt-n2 my-0 title-expansion-cont"
										>
											<p class="mt-2 title-expansion content-expansion content">
												{{
													getTotalSizeWarning(
														extractionsGrouped(item.cameraName),
														panelExt.id
													)
												}}
											</p>
										</v-col>
										<v-col
											cols="5"
											sm="5"
											class="py-2 pt-0 my-0 title-expansion responsive-title"
										>
											<p class="pa-0 ma-0">{{ $t("status") }}</p>
										</v-col>
										<v-col
											cols="7"
											sm="7"
											class="py-2 mt-n4 title-expansion-cont from-to"
										>
											<status-box :status="item.status" class="content" />
										</v-col>
										<v-col cols="5" sm="5" class="pt-2 my-0 title-expansion">
											<p class="pa-0 ma-0">{{ $t("partitions") }}</p>
										</v-col>
										<v-col
											cols="7"
											sm="7"
											class="pt-1 my-0 title-expansion-cont"
										>
											<p class="mt-2 title-expansion content">
												{{ $t("partitionedFileMsg") }}
											</p>
										</v-col>
										<v-col
											cols="7"
											sm="10"
											class="pt-2 my-0 download-col-width title-expansion-cont"
										>
											<p
												v-if="extractionProblems(item)"
												class="title-expansion"
											>
												{{ $t("haveProblems") }}
											</p>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content
									class="expansion-panel-content ml-n5"
								>
									<v-row
										v-for="elem in getExtractionsGrouped(
											extractionsGrouped(item.cameraName),
											panelExt.id
										)"
										:key="elem.index"
										@click="onClick(elem)"
										class="row-align row-divider"
										style="justify-content:flex-start!important"
									>
										<v-col
											cols="4"
											sm="5"
											class="py-2 pt-3 my-0 title-expansion"
											v-if="checkWarnings"
										>
											<p class="pa-0 ma-0">{{ $t("timeRange") }}</p>
										</v-col>
										<v-col cols="7" sm="4" v-if="checkWarnings" class="mt-n2">
											<span class="grey--text content">{{ $t("from") }}</span>
											<span class="content"
												>{{ parseTimePeriod(elem.timeRange.split(" - ")[0]) }}
											</span>
											<br />
											<span class="grey--text content"> {{ $t("to") }} </span>
											<span class="content">{{
												parseTimePeriod(elem.timeRange.split(" - ")[1])
											}}</span>
										</v-col>
										<v-col
											cols="4"
											sm="5"
											class="py-2 pt-4 my-0 title-expansion responsive-title"
											v-if="checkWarnings"
										>
											<p class="pa-0 ma-0">{{ $t("totalSize") }}</p>
										</v-col>
										<v-col cols="7" sm="4" v-if="checkWarnings">
											<span class="content">{{ elem.size }}</span>
										</v-col>
										<v-col
											cols="4"
											sm="5"
											class="py-2 pt-5 my-0 title-expansion responsive-title"
											v-if="checkWarnings"
										>
											<p class="pa-0 ma-0">{{ $t("status") }}</p>
										</v-col>
										<v-col cols="7" sm="4" v-if="checkWarnings">
											<status-box :status="elem.status" class="content" />
										</v-col>
										<v-col
											cols="4"
											sm="5"
											class="pt-4 my-0 title-expansion"
											v-if="checkWarnings"
										>
											<p class="pa-0 ma-0">{{ $t("partitions") }}</p>
										</v-col>
										<v-col
											cols="7"
											sm="4"
											v-if="checkWarnings"
											class="mt-n2 msg-resp"
										>
											<span
												class="content"
												v-for="msg in getWarningsMsg(elem.warning)"
												:key="msg"
											>
												{{ msg }} <br />
											</span>
										</v-col>
										<v-col
											cols="12"
											sm="6"
											v-if="checkWarnings"
											class="pa-0 col-align-details"
										>
											<v-btn
												small
												rounded
												class="white--text mr-2 pa-2 download-cam download-cam-align"
												color="#5f98ed"
												:disabled="singleDownloadNotAllowed(elem)"
												v-on:click.stop="download(elem)"
											>
												{{ $t("download") }}
											</v-btn>
											<v-btn
												text
												class="show-details show-details-align pl-2"
												@click="onClick"
												>{{ $t("showDetails") }}</v-btn
											>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</div>
				</td>
			</template>
		</v-data-table>
		<secondary-organism-modal
			v-if="secondaryOrganismModal"
			v-on:close="closeModal()"
			:secondaryOrganisms="project.secondaryOrganisms"
			:projectOrganism="{ name: project.organismName, id: project.organismId }"
			:projectId="project.id"
			v-on:update="updateSecondaries()"
			@update-secondaries="updateSecondaries"
		/>
	</v-container>
</template>

<script>
import Icon from "@/components/base/Icon";
import DateParseMixin from "@/mixins/DateParseMixin";
import PermissionMixin from "@/mixins/PermissionMixin";

export default {
	components: {
		FileDetailsDrawer: () =>
			import("@/views/detailsView/components/FileDetailsDrawer"),
		AuditDialog: () => import("@/components/base/AuditDialog"),
		TableProjectDetails: () =>
			import("@/views/detailsView/components/TableProjectDetails"),
		Icon,
		SecondaryOrganismModal: () =>
			import("@/views/detailsView/modals/SecondaryOrganismModal"),
	},
	props: {
		icon: String,
	},
	mixins: [DateParseMixin, PermissionMixin],
	data() {
		return {
			project: undefined,
			item: undefined,
			subitem: undefined,
			selected: [],
			//downloadNotAllowed: false,
			showDrawer: false,
			extractionForDrawer: undefined,
			projectName: "",
			drawerKey: 0,
			interval: undefined,
			requestInProgress: false,
			isDown: false,
			fileSize: 0,
			noDate: false,
			key: 0,
			itemsBreadcrumb: [
				{
					text: "Proyectos",
					disabled: false,
					href: "/",
				},
				{
					text: "Detalles",
					disabled: false,
					href: "details",
				},
			],
			secondaryOrganismModal: false,
		};
	},
	computed: {
		detailedProject: {
			get() {
				return this.$store.getters.getDetailedProject;
			},
		},
		processed: {
			get() {
				return {
					projectName: this.projectName,
					status: this.project.status,
				};
			},
		},
		dialog: {
			get() {
				return this.$store.getters.getAuditDialog;
			},
		},
		headers: {
			get() {
				return [
					{
						text: this.$t("name"),
						align: "start",
						sortable: false,
						value: "cameraName",
					},
					{
						text: this.$t("size"),
						align: "start",
						sortable: false,
						value: "size",
					},
					{
						text: this.$t("status"),
						align: "start",
						sortable: false,
						value: "status",
					},
					{
						text: "",
						align: "start",
						sortable: false,
						value: "warning",
					},
				];
			},
		},
		subheaders: {
			get() {
				return [
					{
						text: this.$t("timeRange"),
						align: "left",
						sortable: false,
						value: "timeRange",
						width: "22%",
					},
					{
						text: this.$t("size"),
						align: "left",
						sortable: false,
						value: "size",
						width: "15%",
					},
					{
						text: this.$t("status"),
						align: "start",
						sortable: false,
						value: "status",
						width: "15%",
					},
					{
						text: "",
						align: "start",
						sortable: false,
						value: "warning",
						width: "25%",
					},
					{
						text: "",
						align: "end",
						sortable: false,
						value: "actions",
					},
				];
			},
		},
		extractions: {
			get() {
				if (this.project !== undefined) {
					var res = [];
					this.project.extractions.forEach((extraction) => {
						var i = res.findIndex(
							(element) => element.cameraName === extraction.cameraName
						);
						if (i !== -1) {
							res[i].extractions.splice(
								res[i].extractions.length,
								1,
								extraction
							);
							res[i].size += this.totalSize(extraction.files);
						} else {
							res.push({
								cameraName: extraction.cameraName,
								extractions: [extraction],
								size: this.totalSize(extraction.files),
								status: "",
								warning: this.areThereWarnings(extraction),
								geoLocation: extraction.geoLocation,
							});
						}
					});
					res.forEach((r) => {
						r.size = this.returnSize(r.size);
						r.status = this.returnStatus(r);
					});
					return res;
				} else {
					return [];
				}
			},
		},
		downloadInProgress: {
			get() {
				return (
					this.project !== undefined && this.project.status === "Extracting"
				);
			},
		},
		downloadNotAllowed: {
			get() {
				if (this.project === undefined) {
					return false;
				}
				if (
					this.project.status === "Started" ||
					this.project.status === "Paused"
				)
					return true;
				if (this.$store.getters.getRole === "downloader") {
					if (this.project.status === "Approved") {
						return false;
					}
					return true;
				} else if (this.$store.getters.getRole === "auditor") {
					return false;
				}
				return false;
			},
		},
		checkWarnings: {
			get() {
				return this.project && this.project.cut;
			},
		},
		websocket: {
			get() {
				return this.$store.getters.getWebsocket;
			},
		},
		progressDownload: {
			get() {
				return this.$store.getters.getProgressDownload;
			},
			set(value) {
				return this.$store.commit("setProgressDownload", value);
			},
		},
		updatedSecondaries: {
			get() {
				return this.$store.getters.getSecodaryUpdate;
			},
		},
		disableOrganismButton() {
			if (
				!this.$store.getters.getUserInfo.organismId ||
				!this.project ||
				this.$store.getters.getUserInfo.organismId != this.project.organismId
			) {
				this.$store.commit("setDisableText", "notProjectOwner");
				return true;
			}
			if (!this.project || this.project.status != "Approved") {
				this.$store.commit("setDisableText", "notApprovedProject");
				return true;
			}
			this.$store.commit("setDisableText", null);
			return false;
		},
		getDisableText() {
			return this.$store.getters.getDisabledText;
		},
		isDownloader() {
			return this.$store.getters.getRole == "downloader";
		},
	},
	async mounted() {
		if (this.$route.query.id !== undefined) {
			this.$store.commit("setProjectForDetails", this.$route.query.id);
		}
		await this.getData();

		clearInterval(this.interval);
		this.interval = 0;
		var progress = async function(e) {
			let data = {
				id: "0",
				prog: "0",
			};
			let message = JSON.parse(e.data);
			data.id = message.Message.match(/[0-9]+/g)[0];
			data.prog = message.Message.match(/[0-9]+/g)[1];
			this.progressDownload = data;
		}.bind(this);
		var checkAccess = async function(e) {
			let message = JSON.parse(e.data);
			if (message.Message === this.project.name) {
				await this.getData();
			}
		}.bind(this);
		if (this.$store.getters.getRole === "downloader") {
			this.websocket.Subscribe(
				"notification.vms_extractions_web.downloader." +
					this.$store.getters.getUserInfo.organismId,
				checkAccess
			);
		} else if (this.$store.getters.getRole === "legal_auditor") {
			this.websocket.Subscribe(
				"notification.vms_extractions_web.legal_auditor",
				checkAccess
			);
		} else {
			this.websocket.Subscribe(
				"notification.vms_extractions_web.*.progress",
				progress
			);
			this.websocket.Subscribe(
				"notification.vms_extractions_web.auditor",
				checkAccess
			);
		}
		this.websocket.OnOpen(function() {
			clearInterval(this.interval);
			this.interval = 0;
		});
		this.websocket.OnDisconnection(
			async function() {
				this.interval = setInterval(this.getData, 60000);
			}.bind(this)
		);
		this.websocket.OnClosure(
			async function() {
				this.interval = setInterval(this.getData, 60000);
			}.bind(this)
		);

		this.extractions.forEach((e, index) => {
			if (index % 2 === 0) {
				var elem = document.getElementsByClassName("v-data-table__selected")[
					index
				];
				elem.classList.add("gris");
			}
		});
		this.itemsBreadcrumb.forEach((e, index) => {
			if (e.href === "/") {
				var el = document.getElementsByClassName("v-breadcrumbs__item")[index];
				el.classList.add("gray");
			}
		});
	},
	beforeDestroy() {
		clearInterval(this.interval);
		this.interval = undefined;
		if (this.$store.getters.getRole === "downloader") {
			this.websocket.Unsubscribe(
				"notification.vms_extractions_web.downloader." +
					this.$store.getters.getUserInfo.organismId
			);
		} else if (this.$store.getters.getRole === "legal_auditor") {
			this.websocket.Unsubscribe(
				"notification.vms_extractions_web.legal_auditor"
			);
		} else {
			this.websocket.Unsubscribe("notification.vms_extractions_web.auditor");
			this.websocket.Unsubscribe("notification.vms_extractions_web.*.progress");
		}
	},

	methods: {
		getExtractionsGrouped(item, id) {
			let res = [];
			item.forEach((e) => {
				if (e.id === id) {
					res.push(e);
				}
			});
			return res;
		},
		getExtractions(item) {
			let res = [];
			let ids = [];
			item.forEach((e) => {
				if (!ids.includes(e.id)) {
					res.push(e);
					ids.push(e.id);
				}
			});
			return res;
		},
		getWarningsMsg(text) {
			return text.split(".");
		},
		extractionProblems(item) {
			let noProblems = true;
			item.extractions.forEach((elem) => {
				if (elem.filesAborted !== "" || elem.filesEmpty !== "") {
					noProblems = false;
				}
			});
			return noProblems;
		},
		getMinTime(item) {
			let minDate;
			let min = new Date("3000-12-30");
			let noTime = false;
			item.forEach((elem) => {
				if (this.project.cut) {
					if (elem.timeRange.split(" - ")[0] !== "0001-01-01T00:00:00") {
						let date = new Date(elem.timeRange.split(" - ")[0]);
						if (date <= min) {
							minDate = elem.timeRange.split(" - ")[0];
							min = date;
						}
					} else {
						noTime = true;
						let startDate = elem.timeRangeName.split("-")[0];
						let date = new Date(startDate);
						if (date <= min) {
							minDate = startDate;
							min = date;
						}
					}
				}
			});
			this.noDate = noTime;
			if (noTime) {
				return this.parseTimePeriod(minDate);
			} else {
				return this.parseTimePeriod(minDate);
			}
		},
		getMaxTime(item) {
			let maxDate;
			let max = new Date("1000-12-30");
			let noTime = false;
			item.forEach((elem) => {
				if (this.project.cut) {
					if (elem.timeRange.split(" - ")[1] !== "0001-01-01T00:00:00") {
						let date = new Date(elem.timeRange.split(" - ")[1]);
						if (date >= max) {
							maxDate = elem.timeRange.split(" - ")[1];
							max = date;
						}
					} else {
						noTime = true;
						let endDate = elem.timeRangeName.split("-")[1];
						let date = new Date(endDate);
						if (date >= max) {
							maxDate = endDate;
							max = date;
						}
					}
				}
			});
			if (noTime) {
				return this.parseTimePeriod(maxDate);
			} else {
				return this.parseTimePeriod(maxDate);
			}
		},
		getTotalSizeWarning(item, id) {
			let total = 0;
			item.forEach((elem) => {
				if (this.project.cut && elem.id === id) {
					if (elem.sizeint !== "--") {
						total += elem.sizeint;
					}
				}
			});
			return this.returnSize(total);
		},
		getTotalSize(item) {
			let totalSize = 0;
			item.forEach((elem) => {
				let total = 0;
				elem.files.forEach((file) => {
					total += file.size;
				});
				totalSize = this.returnSize(total);
			});
			return totalSize;
		},
		async getData() {
			await this.$extractions
				.getProject(this.$store.getters.getProject)
				.then((response) => {
					this.project = response.data;
					this.selected = this.extractions;
				})
				.catch((e) => {
					if (e.toString().includes("403")) {
						this.$store.commit("setSnackText", "accessDeniedProject");
						this.$store.commit("setSnackBar", true);
						this.$router.push("/");
					}
				});
		},
		auditResult(value) {
			this.$store.dispatch("setOnDialog", {
				audit: true,
				isLegalAudit: false,
				result: value,
				project: this.project,
			});
		},
		legalAuditResult(value) {
			this.$store.dispatch("setOnDialog", {
				audit: true,
				isLegalAudit: true,
				result: value,
				project: this.project,
			});
		},
		canAudit() {
			if (this.$store.getters.getRole !== "admin")
				return (
					this.userCanAudit &&
					this.project &&
					(this.project.status === "Finished" ||
						this.project.status === "PreApproved" ||
						this.project.status === "Denied")
				);
			else {
				if (
					this.project &&
					(this.project.status === "Finished" ||
						this.project.status === "Denied")
				) {
					return true;
				} else {
					return false;
				}
			}
		},
		canLegalAudit() {
			return (
				this.userCanLegalAudit &&
				this.project &&
				(this.project.status === "PreApproved" ||
					this.project.status === "Approved")
			);
		},
		onClick(item) {
			if (item.name) {
				this.showDrawer = true;
				this.extractionForDrawer = item;
				this.projectName = this.project.name;
				this.drawerKey++;
			}
		},
		totalSize(array) {
			let val = 0;
			array.forEach((el) => (val += el.size));
			return val;
		},
		returnSize(value) {
			if (value === 0) return "--";
			var a = value / 1000000;
			if (a < 1000) {
				return a.toFixed(2).toString() + " MB";
			} else {
				return (a / 1000).toFixed(2).toString() + " GB";
			}
		},
		returnStatus(r) {
			var fine = 0;
			var failed = 0;
			if (
				this.project.status == "Finished" ||
				this.project.status == "Approved" ||
				this.project.status == "Denied"
			) {
				r.extractions.forEach((exts) => {
					if (exts.status !== "Finished") {
						failed++;
					} else {
						fine++;
					}
				});
				if (fine === r.extractions.length) return "Finished";
				else if (failed === r.extractions.length) return "Failed";
				else return "SomeFailed";
			} else {
				return this.project.status;
			}
		},
		updateSelectedItems(event) {
			this.selected.push(event);
		},
		extractionsGrouped(camera) {
			var extractionsForCamera = this.extractions.find(
				(e) => e.cameraName === camera
			);
			if (extractionsForCamera !== undefined) {
				var res = [];
				let ext = extractionsForCamera.extractions.filter((extraction) =>
					extraction.name.includes(camera)
				);
				ext.forEach((extraction) => {
					if (extraction.files && extraction.files.length !== 0) {
						extraction.files.forEach((file) => {
							res.push({
								id: file.id,
								index:
									extraction.files.length >= 1 ? parseInt(file.fileIndex) : 0,
								key: file.id,
								name: extraction.cameraName,
								timeRangeName: extraction.downloadTimeRange,
								timeRange: file.startDateTime + " - " + file.endDateTime,
								size: file.size,
								sizeint: file.size,
								status: extraction.status,
								warning: this.extractionWarnings(extraction, file),
								//kept for compatibility's sake
								interruptions: extraction.gaps,
								gaps: file.gaps,
								geoLocation: extraction.geoLocation,
							});
						});
					}
					if (extraction.filesEmpty && extraction.filesEmpty.length !== 0) {
						extraction.filesEmpty.forEach((file) => {
							res.push({
								id: extraction.files[0] && extraction.files[0].id,
								index:
									extraction.files.length >= 1 ? parseInt(file.fileIndex) : 0,
								key: file.id,
								name: extraction.cameraName,
								timeRange: file.startDateTime + " - " + file.endDateTime,
								timeRangeName: extraction.downloadTimeRange,
								size: file.size,
								sizeint: file.size,
								status: "FailedNoRecordings",
								warning: this.extractionWarnings(extraction, file),
								//kept for compatibility's sake
								interruptions: extraction.gaps,
								gaps: file.gaps,
								geoLocation: extraction.geoLocation,
							});
						});
					}
					if (extraction.filesAborted && extraction.filesAborted.length !== 0) {
						extraction.filesAborted.forEach((file) => {
							res.push({
								id: extraction.files[0] && extraction.files[0].id,
								index:
									extraction.files.length >= 1 ? parseInt(file.fileIndex) : 0,
								key: file.id,
								name: extraction.cameraName,
								timeRange: file.startDateTime + " - " + file.endDateTime,
								timeRangeName: extraction.downloadTimeRange,
								size: file.size,
								sizeint: file.size,
								status: "Failed",
								warning: this.extractionWarnings(extraction, file),
								//kept for compatibility's sake
								interruptions: extraction.gaps,
								gaps: file.gaps,
								geoLocation: extraction.geoLocation,
							});
						});
					}
					if (
						(!extraction.files || extraction.files.length == 0) &&
						(!extraction.filesEmpty || extraction.filesEmpty.length == 0) &&
						(!extraction.filesAborted || extraction.filesAborted.length == 0)
					) {
						res.push({
							id: extraction.files[0] && extraction.files[0].id,
							index: 0,
							name: extraction.cameraName,
							timeRange: extraction.downloadTimeRange,
							timeRangeName: extraction.downloadTimeRange,
							size: "--",
							sizeint: "--",
							status: extraction.status,
							warning: this.extractionWarnings(extraction, null),
							//kept for compatibility's sake
							interruptions: extraction.gaps,
							gaps: [],
						});
					}
				});
				res.forEach((r) => {
					if (r.size !== "--") r.size = this.returnSize(r.size);
				});
				return res.sort((a, b) => (a.index > b.index ? 1 : -1));
			}
			return [];
		},
		checkGaps(extraction) {
			var result = [];
			extraction.files.forEach((file) => {
				file.gaps.forEach((g) => result.push(g));
			});
			return result;
		},
		downloadFiles() {
			this.$store.dispatch("startDownloads", {
				snackDownload: true,
				selected: this.selected,
				project: this.project,
				downloadInProgress: true,
			});
		},
		download(item) {
			this.$store.dispatch("startDownloads", {
				snackDownload: true,
				selected: [item],
				project: this.project,
				downloadInProgress: false,
			});
		},
		downloadSummary() {
			this.$extractions
				.downloadSummary(this.project.id)
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data], { type: "application/pdf" })
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", this.project.name + "_Summary.pdf");
					document.body.appendChild(link);
					link.click();
					window.URL.revokeObjectURL(url);
				})
				.catch((e) => {
					console.log("Error:", e);
					this.$store.commit("setSnackText", this.$t("SummaryPdfError"));
					this.$store.commit("setSnackBar", true);
				});
		},
		areThereWarnings(extraction) {
			//kept for compatibility's sake
			let st = [];
			if (!!extraction.gaps && extraction.gaps.length !== 0) {
				st.push(this.$t("gapsDesc"));
			}
			//for gaps per file
			var i = 0;
			var gapFound = false;
			while (!gapFound && i < extraction.files.length) {
				if (extraction.files[i].gaps.length > 0) {
					gapFound = true;
				}
				i++;
			}
			if (gapFound) {
				st.push(this.$t("gapsDesc"));
			}
			if (extraction.files !== undefined && extraction.files.length > 1) {
				st.push(this.$t("partitionedFile"));
			}

			return st;
		},
		extractionWarnings(extraction, file) {
			let warning = "";
			//kept for compatibility's sake
			if (!!extraction.gaps && extraction.gaps.length !== 0) {
				warning = this.$t("gapsFound");
			}
			//for gaps per file
			if (file === null || file === undefined) return warning;
			if (file.gaps && file.gaps.length != 0) {
				warning = this.$t("gapsFound");
			}

			switch (file.type) {
				case "empty":
					warning += this.$t("emptyFragment");
					break;
				case "aborted":
					warning += this.$t("abortedFragment");
					break;
				default:
					break;
			}
			if (extraction.files.length > 1) {
				warning +=
					this.$t("partFrom") +
					file.fileIndex +
					this.$t("partOf") +
					(extraction.files.length +
						extraction.filesEmpty.length +
						extraction.filesAborted.length);
			} else if (extraction.files.length >= 1 && this.project.cut) {
				warning +=
					this.$t("partFrom") +
					file.fileIndex +
					this.$t("partOf") +
					(extraction.files.length +
						extraction.filesEmpty.length +
						extraction.filesAborted.length);
			} else if (
				extraction.files.length >= 1 &&
				(extraction.filesEmpty.length >= 1 || extraction.filesAborted.length)
			) {
				warning +=
					this.$t("partFrom") +
					file.fileIndex +
					this.$t("partOf") +
					(extraction.files.length +
						extraction.filesEmpty.length +
						extraction.filesAborted.length);
			}
			return warning;
		},
		singleDownloadNotAllowed(item) {
			if (
				item.status === "FailedNoRecordings" ||
				item.status === "Failed" ||
				item.status === "Expired" ||
				item.status === "Cancelled"
			)
				return true;
			if (
				this.processed.status === "Started" ||
				this.processed.status === "Paused" ||
				this.processed.status === "Expired" ||
				this.processed.status === "Failed" ||
				this.processed.status === "Extracting"
			)
				return true;
			if (this.$store.getters.getRole === "downloader") {
				if (this.processed.status === "Approved") {
					return false;
				}
				return true;
			}
			return false;
		},
		shareProject() {
			this.secondaryOrganismModal = true;
		},
		closeModal() {
			this.secondaryOrganismModal = false;
		},
		updateSecondaries: function(secondaries) {
			this.project.secondaryOrganisms = secondaries;
		},
	},
	watch: {
		updatedSecondaries: function(newval) {
			if (newval.Action == "forbid" && newval.ProjectId == this.project.id) {
				this.$store.commit("setSnackText", "accessDeniedProject");
				this.$store.commit("setSnackBar", true);
				this.$router.push("/");
			}
		},
	},
};
</script>
<style>
.table-no-part-resp {
	display: none !important;
}
.title-not-possible {
	font-size: 11px !important;
	font-weight: normal;
}
.col-align-details {
	text-align: center !important;
}
.row-align {
	margin-left: 50px !important;
}
.part-col-align {
	padding-left: 5px !important;
}
.time-col-width {
	max-width: 19% !important;
	min-width: 19% !important;
}
.size-col-width {
	max-width: 11% !important;
	min-width: 11% !important;
	margin-left: 10px !important;
}
.status-col-width {
	max-width: 20% !important;
	min-width: 20% !important;
}
.part-col-width {
	max-width: 22% !important;
	min-width: 22% !important;
}
.download-col-width {
	max-width: 22% !important;
	min-width: 22% !important;
}
.expansion-panel-content .v-expansion-panel-content__wrap {
	padding: 0 !important;
}
.icon-down-up {
	max-width: 4% !important;
}
.expansion-row.row {
	justify-content: flex-start !important;
}
.content-expansion {
	font-size: 14px !important;
}
.title-expansion {
	color: #24243a !important;
	font-size: 13px !important;
	font-weight: bold !important;
}
.expansion-header {
	min-height: 38px !important;
}
.panel .v-expansion-panel {
	border: none !important;
}
.expansion-header .v-expansion-panel-header__icon {
	display: none !important;
}

.cameras-table {
	border: 1px solid #eee;
	border-radius: 18px;
	padding: 30px;
	width: 95%;
	font-family: "Open Sans", "sans-serif";
	font-weight: 500;
}
.theme--light.v-data-table thead tr:last-child th {
	border-bottom: none !important;
}
tr.v-data-table__selected {
	background-color: #fff !important;
}
v.data-table__expanded {
	border-bottom: none !important;
}
tr.v-data-table__selected.gris {
	background-color: #fdfeff !important;
}
.detail-box {
	border: 1px solid #eee;
	border-radius: 10px;
	width: 96%;
	margin-top: 10px;
	margin-left: 20px;
	font-size: 14px;
}
.download {
	color: #5f98ed !important;
}
.download:hover {
	color: #2063c5 !important;
}
.gray {
	color: #888 !important;
}
.v-data-table th {
	font-size: 14px !important;
	color: #24243a !important;
}
.v-data-table-header {
	padding-bottom: 10px !important;
}
.camera-details {
	width: 90%;
	margin-left: 55px;
}
.v-data-table__expanded__content {
	box-shadow: none !important;
}
.download-cam:hover {
	background-color: #2064ca !important;
}
.download-cam .v-btn__content {
	font-size: 11px !important;
}
.show-details::before {
	background-color: transparent !important;
}
.show-details .v-btn__content:hover {
	color: #2063c5 !important;
}
.show-details .v-btn__content {
	font-family: "Open Sans", "sans-serif";
	letter-spacing: 0 !important;
	color: #5f98ed !important;
	font-size: 12px !important;
	text-transform: capitalize !important;
}
.show-details {
	color: #5f98ed !important;
	font-size: 12px !important;
	cursor: pointer !important;
}
.show-details:hover {
	color: #2063c5 !important;
}
.theme--light.v-data-table
	tbody
	tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
	background: #f9f9f9 !important;
}
.camera-name {
	color: #0d5ae5 !important;
	font-weight: bold;
}
.content {
	font-size: 14px !important;
}
.expansion-align {
	margin-left: 90px !important;
}
.time-col-align {
	margin-left: 55px !important;
}
.icon-down-up {
	max-width: 3% !important;
}
.size-col-align {
	margin-left: 22px !important;
}
.timerange-col-width {
	margin-left: 10px !important;
}
.totalsize-col-width {
	margin-left: 22px !important;
}
.part-col-align {
	margin-left: 16px !important;
}
.share-button {
	margin-left: 15px !important;
}
@media (max-width: 3100px) {
	.timerange-col-width {
		margin-left: 15px !important;
	}
}
@media (max-width: 3000px) {
	.part-col-align {
		margin-left: 13px !important;
	}
}
@media (max-width: 3000px) {
	.part-col-align {
		margin-left: 13px !important;
	}
}
@media (max-width: 2900px) {
	.time-col-align {
		margin-left: 55px !important;
	}
	.size-col-align {
		margin-left: 20px !important;
	}
	.part-col-align {
		margin-left: 11px !important;
	}
	.timerange-col-width {
		margin-left: 20px !important;
	}
}
@media (max-width: 2800px) {
	.row-align {
		margin-left: 50px !important;
	}
	.timerange-col-width {
		margin-left: 25px !important;
	}
}
@media (max-width: 2600px) {
	.expansion-align {
		margin-left: 85px !important;
	}
	.row-align {
		margin-left: 48px !important;
	}
	.size-col-align {
		margin-left: 20px !important;
	}
}
@media (max-width: 2550px) {
	.expansion-align {
		margin-left: 80px !important;
	}
	.size-col-align {
		margin-left: 18px !important;
	}
	.part-col-align {
		margin-left: 12px !important;
	}
	.time-col-align {
		margin-left: 45px !important;
	}
	.status-col-align {
		padding-left: 15px !important;
	}
	.totalsize-col-width {
		margin-left: 14px !important;
	}
}
@media (max-width: 2450px) {
	.expansion-align {
		margin-left: 78px !important;
	}
	.time-col-align {
		margin-left: 42px !important;
	}
	.status-col-align {
		padding-left: 15px !important;
	}
	.totalsize-col-width {
		margin-left: 14px !important;
	}
	.size-col-align {
		margin-left: 20px !important;
	}
}
@media (max-width: 2310px) {
	.expansion-align {
		margin-left: 70px !important;
	}
	.time-col-align {
		margin-left: 40px !important;
	}
}
@media (max-width: 2220px) {
	.time-col-align {
		margin-left: 35px !important;
	}
}
@media (max-width: 2050px) {
	.expansion-align {
		margin-left: 60px !important;
	}
	.time-col-align {
		margin-left: 30px !important;
	}
	.timerange-col-width {
		margin-left: 12px !important;
	}
	.totalsize-col-width {
		margin-left: 20px !important;
	}
}
@media (max-width: 2000px) {
	.time-col-align {
		margin-left: 27px !important;
	}
	.totalsize-col-width {
		margin-left: 23px !important;
	}
	.status-col-align {
		padding-left: 10px !important;
	}
}
@media (max-width: 1900px) {
	.time-col-align {
		margin-left: 25px !important;
	}
}
@media (max-width: 1820px) {
	.expansion-align {
		margin-left: 55px !important;
	}
	.time-col-align {
		margin-left: 22px !important;
	}
}
@media (max-width: 1700px) {
	.expansion-align {
		margin-left: 50px !important;
	}
	.time-col-align {
		margin-left: 18px !important;
	}
}

@media (max-width: 1625px) {
	.content {
		font-size: 12px !important;
	}
	.time-col-align {
		margin-left: 15px !important;
	}
}
@media (max-width: 1520px) {
	.expansion-align {
		margin-left: 45px !important;
	}
	.time-col-align {
		margin-left: 12px !important;
	}
}
@media (max-width: 1500px) {
	.show-details {
		display: block;
		text-align: center;
		margin-left: 10px !important;
		margin-top: 0px;
	}
	.timerange-col-width {
		margin-left: 16px !important;
	}
}
@media (max-width: 1445px) {
	.status-col-align {
		padding-left: 15px !important;
	}
	.time-col-align {
		margin-left: 8px !important;
	}
	.size-col-align {
		margin-left: 25px !important;
	}
}
@media (max-width: 1400px) {
	.part-col-align {
		padding-left: 8px !important;
	}
	.status-col-align {
		padding-left: 12px !important;
	}
	.expansion-align {
		margin-left: 40px !important;
	}
}
@media (max-width: 1445px) {
	.status-col-align {
		padding-left: 5px !important;
	}
	.time-col-align {
		margin-left: 8px !important;
	}
}
@media (max-width: 1400px) {
	.part-col-align {
		padding-left: 8px !important;
	}
	.size-col-align {
		margin-left: 12px !important;
	}
	.status-col-align {
		padding-left: 12px !important;
	}
	.expansion-align {
		margin-left: 40px !important;
	}
}
@media (max-width: 1340px) {
	.show-details {
		margin-left: 10px;
	}
	.status-col-width {
		max-width: 22% !important;
		min-width: 22% !important;
	}
	.download-col-width {
		max-width: 19% !important;
		min-width: 19% !important;
	}
	.part-col-align {
		padding-left: 5px !important;
	}
}
@media (max-width: 1285px) {
	.part-col-align {
		padding-left: 4px !important;
	}
	.size-col-align {
		margin-left: 23px !important;
	}
	.status-col-align {
		padding-left: 12px !important;
	}
}

@media (max-width: 1264px) {
	.size-col-align {
		margin-left: 23px !important;
	}
	.status-col-align {
		padding-left: 20px !important;
	}
}
@media (max-width: 1225px) {
	.size-col-align {
		margin-left: 22px !important;
	}
	.status-col-align {
		padding-left: 15px !important;
	}
}
@media (max-width: 1150px) {
	.time-col-align {
		margin-left: 0px !important;
	}
	.size-col-align {
		margin-left: 25px !important;
	}
	.totalsize-col-width {
		margin-left: 15px !important;
	}
}
@media (max-width: 1100px) {
	.expansion-align {
		margin-left: 35px !important;
	}
}
@media (max-width: 1015px) {
	.totalsize-col-width {
		margin-left: 10px !important;
	}
	.size-col-align {
		margin-left: 15px !important;
	}
	.status-col-width {
		max-width: 18% !important;
		min-width: 18% !important;
	}
	.content {
		font-size: 11px !important;
	}
	.expansion-align {
		margin-left: 30px !important;
	}
}
@media (max-width: 959px) {
	.panel {
		display: none !important;
	}
	.msg-resp {
		align-self: flex-end !important;
	}
}
@media (max-width: 960px) {
	.col-align-details {
		text-align: left !important;
	}
	.show-details {
		display: inline-block;
		margin-left: 30px !important;
	}
	.download-cam-align {
		margin-left: 5px !important;
	}
	.show-details-align {
		margin-left: 40px !important;
	}
	.table {
		margin-left: 0px !important;
	}
	.v-application .ml-5 {
		margin-left: 5px !important;
	}
	.cameras-table td {
		font-size: 13px !important;
	}
	.cameras-table th {
		font-size: 13px !important;
	}
	.download-cam .v-btn__content {
		font-size: 10px !important;
	}
	.download-cam {
		font-size: 10px !important;
		width: 75px;
	}
	.v-btn__content {
		font-size: 9px !important;
	}
	.row-divider {
		border-bottom: 1px solid #eee !important;
	}
}

@media (max-width: 900px) {
	.show-details-align {
		margin-left: 30px !important;
	}
}
@media (max-width: 825px) {
	.show-details-align {
		margin-left: 20px !important;
	}
}
@media (max-width: 795px) {
	.show-details {
		margin-left: 0px;
		padding-left: 0px !important;
	}
}
@media (max-width: 765px) {
	.cameras-table td {
		font-size: 12px !important;
	}
	.cameras-table th {
		font-size: 12px !important;
	}
}
@media (max-width: 750px) {
	.show-details-align {
		margin-left: 10px !important;
	}
}
@media (max-width: 685px) {
	.camera-details {
		margin-left: 8px !important;
		width: 95% !important;
	}
	.cameras-table {
		overflow-x: hidden !important;
	}
	.cameras-table td {
		font-size: 13px !important;
	}
	.cameras-table th {
		font-size: 13px !important;
	}
	.download-cam .v-btn__content {
		font-size: 9px !important;
	}
	.download-cam {
		font-size: 7px !important;
		width: 75px;
		height: 23px !important;
	}
	.show-details-align {
		margin-left: 0px !important;
	}
}
@media (max-width: 600px) {
	.panel-content-part {
		display: none !important;
	}
	.table-no-part {
		display: none !important;
	}
	.table-no-part-resp {
		display: inline-block !important;
	}
}
@media (max-width: 550px) {
	.v-application .pb-4 {
		padding-bottom: 5px !important;
	}
	.v-application .pt-4 {
		padding-top: 5px !important;
	}
	.project-container {
		margin: 0px !important;
		padding: 0 !important;
	}
	.header {
		padding-top: 25px;
		padding-bottom: 0px;
	}
}
@media (max-width: 480px) {
	.content {
		font-size: 10px !important;
	}
	.title-expansion {
		font-size: 10px !important;
	}
	.title-expansion-cont {
		font-size: 8px !important;
	}
	/*.v-data-table .v-data-table__mobile-row{
      width: 98%!important;
    }*/
	.v-data-table__mobile-row__header {
		width: 20% !important;
	}
	.cameras-table {
		padding-left: 5px !important;
	}
	.camera-name {
		font-size: 12px !important;
	}
}
</style>
